module.exports = __webpack_public_path__ + "static/guides-background-8d408d279e8ed5ad0799896b52b997ce.jpg";